import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import isDesktop from 'store/app/selector/isDesktop';
import OpPlusLogo from 'components/Common/Icons/opplus/OpPlusLogo';
import styles from './SubscriptionCompact.module.scss';

export interface SubscriptionCompactProps {
  txtMemberSince: string;
  memberSinceDate: string;
  txtTotalOrders: string;
  totalOrders: string;
  txtMoneySaved: string;
  moneySaved: string;
}

const SubscriptionCompact: FC<SubscriptionCompactProps> = ({
  memberSinceDate,
  moneySaved,
  totalOrders,
  txtMemberSince,
  txtMoneySaved,
  txtTotalOrders,
}) => {
  const isDesktopDevice = useSelector(isDesktop);

  return (
    <div className={styles.container}>
      <OpPlusLogo />
      {isDesktopDevice && <div className={styles.divider} />}
      <div className={styles.subscriptionDetails}>
        <div className={styles.detail}>
          <div className={styles.detail__header}>{txtMemberSince}</div>
          <div className={styles.detail__content}>{memberSinceDate}</div>
        </div>
        <div className={styles.detail}>
          <div className={styles.detail__header}>{txtTotalOrders}</div>
          <div className={styles.detail__content}>{totalOrders}</div>
        </div>
        <div className={styles.detail}>
          <div className={styles.detail__header}>{txtMoneySaved}</div>
          <div className={styles.detail__content} dangerouslySetInnerHTML={{ __html: moneySaved }} />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCompact;
